import Gobalstore from "../index";
export const actions = {
  /* Category */
  getCategories: function (localStore, sec_code) {
    Gobalstore.commit("LoadingOverlay", true);
    this.axios({
      method: "GET",
      url: `/admin/guarded/management/sector/category/${sec_code}`,
    })
      .then(function (response) {
        localStore.commit("setCatagories", response.data);
        Gobalstore.commit("LoadingOverlay", false);
      })
      .catch(function () {
        Gobalstore.commit("LoadingOverlay", false);
      });
  },

  getCategoryDetail: function (localStore, cate_id) {
    Gobalstore.commit("LoadingOverlay", true);
    this.axios({
      method: "GET",
      url: `/admin/guarded/management/sector/category/detail/${cate_id}`,
    })
      .then(function (response) {
        localStore.commit("setCatagory", response.data);
        Gobalstore.commit("LoadingOverlay", false);
      })
      .catch(function () {
        Gobalstore.commit("LoadingOverlay", false);
      });
  },

  createCategory: function (localStore, category) {
    this.axios({
      method: "POST",
      url: `/admin/guarded/management/sector/category/`,
      data: category,
    }).then(function (res) {
      localStore.commit("addCatagories", res.data);
    });
  },

  deleteCategory: function (localStore, category) {
    Gobalstore.commit("LoadingOverlay", true);
    this.axios({
      method: "DELETE",
      url: `/admin/guarded/management/sector/category/`,
      data: category,
    })
      .then(function () {
        localStore.commit("removeCatagory", category);
        Gobalstore.commit("LoadingOverlay", false);
      })
      .catch(function () {
        Gobalstore.commit("LoadingOverlay", false);
      });
  },

  updateCategory: function (localStore) {
    return new Promise((resolve, reject) => {
      this.axios({
        method: "PUT",
        url: `/admin/guarded/management/sector/category/`,
        data: localStore.state.category,
      })
        .then(function (res) {
          localStore.dispatch(
            "getCategoryDetail",
            localStore.state.category.cate_id
          );
          resolve(res);
        })
        .catch(function (err) {
          reject(err);
        });
    });
  },

  /* docChecklist */
  docChecklistAdd: function (localStore, checklist) {
    Gobalstore.commit("LoadingOverlay", true);
    this.axios({
      method: "POST",
      url: `/admin/guarded/management/sector/category/document-checklist`,
      data: checklist,
    })
      .then(function () {
        Gobalstore.commit("LoadingOverlay", false);
        Gobalstore.commit("snackbarSuccess", true);
        localStore.dispatch("getCategoryDetail", checklist[0].cate_id);
      })
      .catch(function () {
        Gobalstore.commit("LoadingOverlay", false);
      });
  },

  docChecklistUpdate: function (localStore, checklist) {
    Gobalstore.commit("LoadingOverlay", true);
    this.axios({
      method: "PUT",
      url: `/admin/guarded/management/sector/category/document-checklist`,
      data: checklist,
    })
      .then(function () {
        Gobalstore.commit("LoadingOverlay", false);
        Gobalstore.commit("snackbarSuccess", true);
      })
      .catch(function () {
        Gobalstore.commit("LoadingOverlay", false);
      });
  },

  docChecklistRemove: function (localStore, checklist) {
    Gobalstore.commit("LoadingOverlay", true);
    this.axios({
      method: "DELETE",
      url: `/admin/guarded/management/sector/category/document-checklist/${checklist.cdc_id}`,
      data: checklist,
    })
      .then(function () {
        Gobalstore.commit("LoadingOverlay", false);
        Gobalstore.commit("snackbarSuccess", true);
        localStore.dispatch("getCategoryDetail", checklist.cate_id);
      })
      .catch(function () {
        Gobalstore.commit("LoadingOverlay", false);
      });
  },

  /* */
  getDocCheckList: function (localStore, entId) {
    this.axios({
      method: "GET",
      url: `/admin/guarded/main/entreaty/doc-checklist/${entId}`,
    }).then(function (response) {
      localStore.commit("setDocChecklist", response.data);
    });
  },

  /* */
  createCategoryType: function (localStore, type) {
    this.axios({
      method: "POST",
      url: `/admin/guarded/management/sector/category/type-create`,
      data: type,
    }).then(function () {
      localStore.dispatch("getCategoryDetail", type.cate_id);
      Gobalstore.commit("snackbarSuccess", true);
    });
  },

  deleteCategoryType: function (localStore, type) {
    this.axios({
      method: "PATCH",
      url: `/admin/guarded/management/sector/category/type-delete`,
      data: type,
    }).then(function () {
      localStore.dispatch("getCategoryDetail", type.cate_id);
      Gobalstore.commit("snackbarSuccess", true);
    });
  },
};
